module.exports = __webpack_public_path__ + "2fa1be4852c5827d76fc0ab68d0c0ae7.png";